module.exports = "/_next/static/images/nr-43db7339cd730655dfc74c430503be4f.svg";